import { Dayjs } from "dayjs";
import useAccount from "@/store/modules/account";
import usePermission from "@/store/modules/permission";
import cache from "@/utils/cache";
import { ACCOUNT } from "@/global/constant";
// import { formatTimeStamp } from "@/utils";

export const GA_MEASUREMENT_ID = "G-FKPL0Q9SWD";
function registerGtag(): void {
  const customMap = {
    dimension1: "user_name",
    dimension2: "page_name",
    dimension3: "button_name",
    dimension4: "send_time"
  };
  window.gtag("config", GA_MEASUREMENT_ID, {
    custom_map: customMap
  });
  window.gtag("config", GA_MEASUREMENT_ID, {
    send_page_view: false
  });
}

interface PageView {
  page_name: string;
  page_path: string;
  enter_time: Dayjs;
  leave_time: Dayjs;
}

export function useEmitPageView(payload: PageView) {
  const account = useAccount();
  const { page_name, leave_time, enter_time, page_path } = payload;
  const user_name =
    account.userInfo.account || cache.getCache(ACCOUNT)?.account;
  if (!user_name) {
    return;
  }
  const params = {
    user_name: user_name,
    page_name: page_name,
    page_path: page_path,
    send_time: new Date().toLocaleString().replaceAll("/", "-"),
    value: leave_time.diff(enter_time, "second")
  };

  if (window.gtag) {
    window.gtag("event", "page_view", params);
  }
}

document.addEventListener("click", (e: any) => {
  const btnType = ["button", "submit"];
  const account = useAccount();
  const mapName = usePermission().routeNameMap;
  const hash = window.location.hash;
  const routePath = hash.slice(
    1,
    hash.indexOf("?") > 0 ? hash.indexOf("?") : undefined
  );
  if (btnType.includes(e.target?.getAttribute("type") as string)) {
    const params = {
      page_name: mapName[routePath],
      button_name: mapName[routePath] + "/" + e.target.innerText,
      user_name: account.userInfo.account || cache.getCache(ACCOUNT)?.account,
      value: 1
    };
    window.gtag("event", "click", params);
    return;
  }
  // 按钮文字span
  const parentEle = e.target?.parentElement as HTMLElement;
  if (parentEle && btnType.includes(parentEle.getAttribute("type") as string)) {
    const params = {
      page_name: mapName[routePath],
      button_name: mapName[routePath] + "/" + e.target.innerText,
      user_name: account.userInfo.account || cache.getCache(ACCOUNT)?.account,
      value: 1
    };
    window.gtag("event", "click", params);
  }
});

export default registerGtag;
